import { inject, Injectable, signal } from '@angular/core';
import { CommonHttpService } from '../../common-http.service';
import { catchError, from, Observable, pipe, switchMap, tap, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpUrlEncodingCodec } from '@angular/common/http';
import { ITextMessagesConfigDTO } from '../../../models/ITextMessagesConfigDTO';

@Injectable({
  providedIn: 'root'
})
export class TextMessagesConfigService {

  private httpService = inject(CommonHttpService);
  private oidcSecurityService = inject(OidcSecurityService);
  private http = inject(HttpClient);


  textMessagesConfigSignal = signal<ITextMessagesConfigDTO | null>(null);

  constructor() { }

  public getTextMessageConfig(): Observable<ITextMessagesConfigDTO> {
    const url = `${environment.apiUrl}/v3/accounts/my-account/text-messages-config`;

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {

        if (authResult.isAuthenticated) {
          let headers = new HttpHeaders();
          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);

          return this.httpService.get<ITextMessagesConfigDTO>(url, undefined, headers);
        } else {
          return throwError(() => new Error('User is not authenticated'));
        }
      }),
      tap(response => {
        this.textMessagesConfigSignal.set(response);
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg = typeof error.error === 'string' ? error.error : 'Unknown Error';
        return throwError(() => new Error(errorMsg));
      })
    );
  }

  public putTextMessagesConfigInfo(data: ITextMessagesConfigDTO): Observable<any> {

    const url = `${environment.apiUrl}/v3/accounts/my-account/text-messages-config`;

    let bodyString = new HttpParams({
      encoder: new HttpUrlEncodingCodec(),
    });
    bodyString = bodyString
      .append('textMessagesConfig', JSON.stringify(data))
    
    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          let headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
          });
          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);
          return this.http.put<string>(url, bodyString.toString(), {
            headers,
            responseType: 'text' as 'json'
          });
        } else {
          return throwError(() => new Error('unauthenticated user or expired token'));
        }
      }),

    )
  }
}


